/* esm.sh - @radix-ui/react-presence@1.1.5 */
export * from "/*@radix-ui/react-presence@1.1.5/esnext/react-presence.mjs";
